console.log('Offers block script loaded');  
function equalizeHeights(elements) {
    if (!elements.length) {
        return;
    }

    elements.forEach(element => {
        element.style.minHeight = '';
    });

    let maxHeight = 0;

    elements.forEach(element => {
        const height = element.offsetHeight;
        if (height > maxHeight) {
            maxHeight = height;
        }
    });

    if (!maxHeight) {
        return;
    }

    elements.forEach(element => {
        element.style.minHeight = `${maxHeight}px`;
    });
}

function resetHeights(elements) {
    elements.forEach(element => {
        element.style.minHeight = '';
    });
}

function initOffersEqualHeights() {
    const section = document.querySelector('.offers');

    if (!section) {
        return;
    }

    const titles = Array.from(section.querySelectorAll('.js-offers-title'));
    const descriptions = Array.from(section.querySelectorAll('.js-offers-desc'));

    if (!titles.length || !descriptions.length) {
        return;
    }

    const isDesktopLayout = window.matchMedia('(min-width: 768px)').matches;

    if (!isDesktopLayout) {
        resetHeights(titles);
        resetHeights(descriptions);
        return;
    }

    equalizeHeights(titles);
    equalizeHeights(descriptions);
}

function scheduleOffersEqualHeights() {
    requestAnimationFrame(() => {
        initOffersEqualHeights();
        requestAnimationFrame(initOffersEqualHeights);
    });
}

function bootOffersEqualHeights() {
    if (!document.querySelector('.offers .js-offers-title')) {
        return;
    }

    scheduleOffersEqualHeights();

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(scheduleOffersEqualHeights);
    }

    window.addEventListener('load', scheduleOffersEqualHeights);
    window.addEventListener('resize', scheduleOffersEqualHeights);
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootOffersEqualHeights);
} else {
    bootOffersEqualHeights();
}
